import { Button, Input, message } from "antd"
import React, { useRef } from "react"
import restful from "../../restful"

import { FC } from "react";

const UploadFileField: FC = (props: any) => {

    const [loading, setLoading] = React.useState(false)
    const inputFileRef = useRef<any>();

    const onBtnClick = () => {
        /*Collecting node-element and performing click*/
        inputFileRef.current.click();
    }
    const onChange = async (e: any) => {
        let formData = new FormData();
        formData.append("file", e.target.files[0]);
        setLoading(true)
        const res = await restful.post("/uploads/image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        }).catch((err) => message.error(err.message))

        setLoading(false)
        props.onChange(res.data.result.link)
    }

    return (
        <>
            <input type={'file'} ref={inputFileRef} style={{ display: 'none' }} onChange={onChange} />
            <Input.Group compact  >
                <Input disabled={loading} style={{ width: 'calc( 100% - 100px)' }} value={props.value} />
                <Button loading={loading} type="primary" style={{ width: '100px' }} onClick={onBtnClick}>آپلود</Button>
            </Input.Group>
        </>
    )
}

export default UploadFileField
